<template>
    <div class="row">
        <div class="col-md-12">
            <div class="card-box m-0">
                <form role="form" @submit.prevent="doFilter(1)">
                    <div class="input-group m-b-15">
                        <input type="text" v-model="filter.search" class="form-control input_search" :placeholder="$t('_quotations.filter_main_field_placeholder')">
                        <span class="input-group-btn">
                            <span class="btn btn_green" @click.prevent="doFilter(1)" v-pml-tooltip="$t('filter')">
                                <i class="fa fa-fw fa-search"></i>
                            </span>
                            <span class="btn btn_light" @click.prevent="showAdvancedFilter = !showAdvancedFilter" v-pml-tooltip="$t('filter_advanced')">
                                <i class="fa fa-fw fa-chevron-up" :class="{ 'fa-chevron-down': !showAdvancedFilter }"></i>
                            </span>
                        </span>
                    </div>
                    <div v-show="showAdvancedFilter">
                        <div class="row">
                            <div class="col-xs-12 col-sm-6 m-b-15">
                                <label>{{ $t('issue_date') }}</label>
                                <div class="input-daterange input-group">
                                    <pml-date-picker v-model="filter.issue_date_at_from"></pml-date-picker>
                                    <span class="input-group-addon b-0"><i class="fa fa-calendar"></i></span>
                                    <pml-date-picker v-model="filter.issue_date_at_to"></pml-date-picker>
                                </div>
                            </div>
                            <div class="col-xs-12 col-sm-6 m-b-15">
                                <label>{{ $t('due_date') }}</label>
                                <div class="input-daterange input-group">
                                    <pml-date-picker v-model="filter.due_date_at_from"></pml-date-picker>
                                    <span class="input-group-addon b-0"><i class="fa fa-calendar"></i></span>
                                    <pml-date-picker v-model="filter.due_date_at_to"></pml-date-picker>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-xs-12 col-sm-6 m-b-15">
                                <label>{{ $t('status') }} <small class="text-muted">({{ $t('quotation') }})</small></label>
                                <pml-multiselect v-model="filter.status_s" :options="status"></pml-multiselect>
                            </div>
                            <div class="col-xs-12 col-sm-6 m-b-15">
                                <label>{{ $t('status') }} <small class="text-muted">({{ $t('deal') }})</small></label>
                                <pml-multiselect v-model="filter.deal_status_s" :options="dealStatus"></pml-multiselect>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-xs-12 col-sm-6 m-b-15">
                                <label>{{ $t('source') }}</label>
                                <pml-select v-model="filter.source_id" :options="sources"></pml-select>
                            </div>
                            <div class="col-xs-12 col-sm-6 m-b-15">
                                <label>{{ $t('segment') }}</label>
                                <pml-select v-model="filter.segment_id" :options="segments"></pml-select>
                            </div>
                        </div>
                    </div>
                    <hr class="m-t-0">
                    <div class="clearfix">
                        <button class="btn btn-white pull-left" @click.prevent="clear()"><i class="fa fa-paint-brush m-r-5"></i>{{ $t('clear') }}</button>
                        <button class="btn btn_green pull-right" type="submit">
                            <span class="btn-label">
                                <i class="fa fa-search"></i>
                            </span>
                            {{ $t('filter') }}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>

<script>
    import bus from 'utils/events/bus'
    import Notify from 'utils/helpers/notify'
    import { trans } from 'utils/helpers/translation'
    import { getAllPaged } from 'services/quotations'
    import { mapGetters } from 'vuex'
    import { isEmpty, forEach } from 'lodash'

    export default {
        name: 'QuotationsFilter',
        data () {
            return {
                page: 1,
                pagination: {
                    from: 0,
                    to: 0,
                    total: 0
                },
                showAdvancedFilter: false,
                filter: {
                    issue_date_at_from: '',
                    issue_date_at_to: '',
                    due_date_at_from: '',
                    due_date_at_to: '',
                    source_id: null,
                    segment_id: null,
                    orderBy: 'issue_date_at',
                    orderDirection: 'desc',
                    status_s: [ 'new', 'sent' ],
                    deal_status_s: [ 'open' ]
                }
            }
        },
        computed: {
            ...mapGetters({
                'sources': 'getSources',
                'segments': 'getSegments',
                'status': 'getQuotationStatus',
                'dealStatus': 'getDealStatus'
            })
        },
        created () {
            bus.$on('doFilterQuotations', this.doFilter)
        },
        destroyed () {
            bus.$off('doFilterQuotations')
        },
        mounted () {
            this.setSearchField()
            this.doFilter(1)
        },
        watch: {
            '$route' (val, old) {
                if (val.query.search !== old.query.search) {
                    this.setSearchField()
                    this.doFilter(1)
                }
            }
        },
        methods: {
            setSearchField () {
                if (isEmpty(this.$route.query)) return

                forEach(this.$route.query, (val, index) => {
                    if (typeof this.filter[index] === 'object')
                        this.filter[index] = [val]
                    else
                        this.filter[index] = val
                })
            },
            clear () {
                this.filter = {
                    issue_date_at_from: '',
                    issue_date_at_to: '',
                    due_date_at_from: '',
                    due_date_at_to: '',
                    source_id: null,
                    segment_id: null,
                    orderBy: 'issue_date_at',
                    orderDirection: 'desc',
                    status_s: [ 'new', 'sent' ],
                    deal_status_s: [ 'open' ]
                }
                this.doFilter(1)
            },
            doFilter (page = null) {
                bus.$emit('listLoadingQuotations', true)

                this.page = page === null ? this.page : page

                getAllPaged(this.page, this.filter)
                    .then(response => {
                        this.pagination = response.data
                        bus.$emit('paginationRefreshQuotations', response.data)
                    })
                    .catch(() => Notify.error(trans('_notifications.error')))
                    .then(() => bus.$emit('listLoadingQuotations', false))
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/modules/quotations/components/Filter.vue